<template>
	<ui-button
		:disabled="disabled"
		:icon="showConfirm ? confirmIcon || icon : icon"
		:floating="floating"
		:primary="primary"
		:raised="showConfirm"
		:secondary="secondary"
		:text="showConfirm ? confirmText || text : text"
		:tooltip="tooltip"
		:type="type"
		@click="onClick"
		@mouseleave="resetConfirm"
	/>
</template>

<script>
import UiButton from "lib/components/ui/Button";

export default {
	name: "ConfirmButton",
	components: {
		UiButton
	},
	mixins: [UiButton],
	props: {
		confirmIcon: {
			type: String,
			default: "",
			required: false
		},
		confirmText: {
			type: String,
			default: "",
			required: false
		}
	},
	data() {
		return {
			showConfirm: false
		};
	},
	methods: {
		onClick() {
			if (this.showConfirm)
				this.$emit("click");
			else
				this.showConfirm = true;
		},
		resetConfirm() {
			if (this.showConfirm)
				this.showConfirm = false;
		}
	}
};
</script>
